import { Brands } from '../models/brands';
import React, { ReactElement } from 'react';
import URockedLogoMonoTextBlue from '../components/common/svg/URockedLogoMonoTextBlue';
import URockedLogoMonoTextWhite from '../components/common/svg/URockedLogoMonoTextWhite';
import BlueInfoIcon from '../components/common/svg/BlueInfoIcon';
import HelpIcon from '../components/common/svg/HelpIcon';
import BankIcon from '../components/common/svg/BankIcon';
import PizzaHutIcon from '../components/common/svg/PizzaHutIcon';
import SendTipIcon from '../components/common/svg/SendTipIcon';

export interface Styling {
    logo: ReactElement;
    header: string;
    checkbox: string;
    helpIcon: ReactElement;
    tooltipStyle: string;
    backIconFill: string;
    bankIcon: ReactElement;
    tipButton: string;
    tipButtonFocus: string;
    buttonPrimary: string;
    buttonPrimaryDisabled: string;
    buttonSecondary: string;
    sendTipIcon: ReactElement;
}
export class BrandStyling {

    private static readonly defaultStyling: Styling = {
        logo: <URockedLogoMonoTextBlue className="h-full w-auto" />,
        header: 'bg-white',
        checkbox: 'accent-pressed-blue text-pressed-blue border-pressed-blue',
        helpIcon: <BlueInfoIcon className="ml-2" />,
        tooltipStyle: 'border-sky-blue',
        backIconFill: '#072648',
        bankIcon: <BankIcon className="mx-12 mt-0 h-20 self-center" />,
        tipButton: 'bg-sky-blue text-primary-1',
        tipButtonFocus: 'bg-accent-blue text-primary-1',
        buttonPrimary: 'bg-primary-1',
        buttonPrimaryDisabled: 'bg-disabled-blue text-blue-grey',
        buttonSecondary: 'border-sky-blue text-primary-2',
        sendTipIcon: <SendTipIcon className="mx-12 mt-0 h-20 self-center" />,
    }

    private static readonly styling: Map<Brands, Partial<Styling>> = new Map([
        [Brands.URocked, {}],

        [Brands.PizzaHut, {
            logo: <URockedLogoMonoTextWhite className="h-full w-auto" />,
            header: 'bg-pizza-hut-red',
            checkbox: 'accent-black text-black border-black',
            helpIcon: <HelpIcon className="ml-2" />,
            tooltipStyle: 'border-pizza-hut-red',
            backIconFill: '#fff',
            bankIcon: <PizzaHutIcon className="mx-12 mt-0 h-20 self-center" />,
            tipButton: 'bg-pizza-hut-red text-surface',
            tipButtonFocus: 'bg-surface text-pizza-hut-red border',
            buttonPrimary: 'bg-pizza-hut-red',
            buttonPrimaryDisabled: 'bg-disabled-blue text-blue-grey',
            buttonSecondary: 'border-pizza-hut-red text-black',
            sendTipIcon: <PizzaHutIcon className="mx-12 mt-0 h-20 self-center" />,
        }],
    ]);

    public static byBrand(brandId: Brands): Styling {
        return {...BrandStyling.defaultStyling, ...BrandStyling.styling.get(brandId)};
    }
}